import React from "react";
import "./TeamAndInfrastructure.css"; // Create this CSS file for styling
import OurTech from '../assets/imases/techno.jpg';



const TeamAndInfrastructure = () => (
    <div>
        {/* OUR TEAM Section */}
        <section className="section-container">
            <h2 className="section-title">OUR TEAM</h2>
            <div className="section-row">
                <div className="section-col section-col-text">
                    <h3 className="section-subtitle">OUR TECHNOLOGY TEAM</h3>
                    <p>
                        At Powerman, our strength lies in our highly skilled and experienced technical team that drives our success. With deep expertise in industrial air compressors, workshop equipment, and innovative machinery solutions, our team ensures every product meets the highest standards of performance, safety, and reliability. From design, installation, and maintenance to after-sales support, they work closely with customers to provide tailored solutions that enhance productivity. Their problem-solving approach, combined with continuous training and knowledge of the latest technologies, allows Powerman to deliver unmatched support, ensuring businesses can count on us for dependable and efficient service.
                    </p>
                </div>
                <div className="section-col section-col-img">
                    <img
                        src={OurTech}
                        alt="Our Technology Team"
                        className="section-image"
                    />
                </div>
            </div>
        </section>

        {/* INFRASTRUCTURE Section */}
        <section className="section-container">
            <h2 className="section-title">INFRASTRUCTURE</h2>
            <div className="section-row">
                <div className="section-col section-col-video">
                    <iframe
                        src="https://www.youtube.com/embed/t2B031TyFyU?autoplay=1&mute=1"
                        title="Infrastructure Video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        loop
                    ></iframe>
                </div>
                <div className="section-col section-col-text">
                    <h3 className="section-subtitle">BEST-IN-CLASS INFRASTRUCTURE</h3>
                    <p>
                        At Powerman Infrastructure, we deliver reliability and innovation through a strong portfolio of over 100+ products. Each solution is engineered for durability, efficiency, and long service life. With continuous technological upgrades and customer-focused design, Powerman stands as a trusted name in infrastructure, supporting businesses with quality, strength, and future-ready solutions across diverse industries.
                    </p>
                    <strong>To know more, watch the video</strong>
                </div>
            </div>
        </section>

    </div>
);

export default TeamAndInfrastructure;